import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const auth = useSelector((state) => state.auth);
  const isAuthenticated = !!auth.accessToken;
  return !isAuthenticated ? <Navigate to={"/"} /> : children || <Outlet />;
}
